class IirDifferentialFilter {
  private feedforward: number[];
  private feedback: number[];

  constructor(dt: number) {
    this.feedforward = [1.0 / dt, -1.0 / dt];
    this.feedback = [];
  }

  applyIirFilter(x: number[]): number[] {
    const y: number[] = new Array(x.length).fill(0);

    for (let n = 0; n < x.length; n++) {
      let temp = 0;

      for (let i = 0; i < this.feedforward.length && n - i >= 0; i++) {
        temp += this.feedforward[i] * x[n - i];
      }

      for (let j = 0; j < this.feedback.length && n - j - 1 >= 0; j++) {
        temp -= this.feedback[j] * y[n - j - 1];
      }

      y[n] = temp;
    }

    return y;
  }
}

function computeDifferential(
  traceData: number[],
  descalingFactor: number,
  sampleRate: number
): number {
  const differentialFilter = new IirDifferentialFilter(1.0 / sampleRate);

  const filteredData = differentialFilter.applyIirFilter(
    traceData.map((s) => s * descalingFactor)
  );
  const maxVal: number = Math.max(...filteredData);
  return parseFloat(maxVal.toFixed(1));
}

export default computeDifferential;
